<script>
import TextInput from "../TextInput";

import Cleave from "cleave.js";

export default {
  extends: TextInput,

  name: "CreditCardInput",

  props: {
    type: {
      type: String,
      default: "credit-card",
      validator(type) {
        return ["credit-card"].includes(type);
      },
    },
  },

  computed: {
    nativeType() {
      return "number";
    },
    inputmode() {
      return "numeric";
    },
  },

  methods: {
    initializeCleave() {
      this.cleave = new Cleave(this.$refs.$input, {
        creditCard: true,
        delimiter: "",
        onCreditCardTypeChanged: type => {
          this.$emit("update:creditCardType", type);
        },
      });
    },

    onInput() {
      setTimeout(
        () => this.$emit("update:value", this.cleave.properties.result),
        15,
      );
    },
  },

  mounted() {
    this.initializeCleave();
    if (this.value) {
      this.hasFocus = true;
    }
  },
};
</script>
